import { CategoriesResponse } from '@shopby/shop-sdk'
import axios from 'axios'
import { memo, useCallback, useEffect, useMemo, useState } from 'react'
import { ProfileRootType } from '../@types/auth'
import { EventContentType, HomeSectionType } from '../@types/home'
import { getProfile } from '../api/auth'
import { getEvents, getSections } from '../api/home'
import { getMenu } from '../api/login'
import { getCategories, getFavoriteKeywords } from '../api/product'
import BrandRecommend from './home/BrandRecommend'
import BrandTheme from './home/BrandTheme'
import CategoryRanking from './home/CategoryRanking'
import CategoryRankingTop from './home/CategoryRankingTop'
import CategoryReview from './home/CategoryReview'
import CategorySecond from './home/CategorySecond'
import EventProduct from './home/EventProduct'
import HomeCart from './home/HomeCart'
import HomeCategory from './home/HomeCategory'
import HomeCategorySecond from './home/HomeCategorySecond'
import HomeQuick from './home/HomeQuick'
import HomeReview from './home/HomeReview'
import HotDeal from './home/HotDeal'
import HotEvent from './home/HotEvent'
import MemberReview from './home/MemberReview'
import PopularSearchKeyword from './home/PopularSearchKeyword'

import { useCommonContext } from './provider/CommonProvider'

const HomeModules = () => {
  const [homeModules, setHomeModules] = useState<HomeSectionType[]>([])
  const [category, setCategory] = useState<CategoriesResponse | null>(null)
  const [hotDealCount, setHotDealCount] = useState(1)
  const [popularKeyword, setPopularKeyword] = useState<string[]>([])
  const [quickMenu, setQuickMenu] = useState([])
  const [userData, setUserData] = useState<ProfileRootType | null>(null)
  const [tagName, setTagName] = useState<Array<string>>([])
  // FIXME: checkTag 와 checkTagNumber 가 같은 것 같은데 왜 두개로 나눠놨는지 확인 필요
  const [checkTag, setCheckTag] = useState<number>(0)
  const [eventTagItem, setEventTagItem] = useState<EventContentType[]>([])
  const { hasAccessToken } = useCommonContext()

  useEffect(() => {
    const fetchData = async () => {
      try {
        const categoriesRes = await getCategories()

        const [sectionsRes, keywordRes, menuRes] = await axios.all([getSections(), getFavoriteKeywords(), getMenu()])
        const sortedSections = sectionsRes.data.sections.sort(
          (a: HomeSectionType, b: HomeSectionType) => Number(a.sectionId) - Number(b.sectionId)
        )
        setHomeModules(sortedSections)
        setCategory(categoriesRes.data)
        setPopularKeyword(keywordRes.data)
        setQuickMenu(menuRes.data.quickMenus)

        if (hasAccessToken) {
          const profileRes = await getProfile()
          setUserData(profileRes.data)
        }
      } catch (error) {
        console.error('Error fetching data:', error)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    const fetchEvents = async () => {
      if (tagName) {
        try {
          const eventsRes = await getEvents(tagName.join(','))
          setEventTagItem(eventsRes.data?.contents)
        } catch (err) {
          console.log(err)
        }
      }
    }

    fetchEvents()
  }, [])

  const memoizedCategory = useMemo(() => category, [category])

  // FIXME: 성능최적화 완료 후 삭제 예정
  // const renderModule = (module: HomeSectionType, index: number) => {
  //   switch (module.sectionName) {
  //     case '핫딜 모듈':
  //       if (hotDealCount !== 0) {
  //         return (
  //           <HotDeal
  //             key={module.sectionNo}
  //             el={module}
  //             index={index}
  //             setHotDealCount={setHotDealCount}
  //             category={memoizedCategory}
  //           />
  //         );
  //       }
  //       break;
  //     case '퀵메뉴':
  //       return <HomeQuick key={module.sectionNo} el={module} index={index} menu={quickMenu} />;
  //     case '검색 모듈':
  //       return (
  //         <PopularSearchKeyword key={module.sectionNo} el={module} index={index} popularKeyword={popularKeyword} />
  //       );
  //     case '카테고리 판매순 TOP4 모듈':
  //       return <CategoryRanking key={module.sectionNo} el={module} index={index} category={memoizedCategory} />;
  //     case '조회수 TOP4 모듈':
  //     case '판매순 TOP4 모듈':
  //     case '검색량 TOP4 모듈':
  //       return (
  //         <CategoryRankingTop
  //           key={module.sectionNo}
  //           el={module}
  //           index={index}
  //           popularKeyword={popularKeyword}
  //           categorys={memoizedCategory}
  //         />
  //       );
  //     case '가로 스크롤 모듈':
  //       return <BrandTheme key={module.sectionNo} el={module} index={index} category={memoizedCategory} />;
  //     case '인플루언서 리뷰 모듈':
  //       return <HomeReview key={module.sectionNo} el={module} index={index} userData={userData} />;
  //     case '기획전 모듈':
  //       return (
  //         <HotEvent
  //           key={module.sectionNo}
  //           el={module}
  //           index={index}
  //           setTagName={setTagName}
  //           setCheckTag={setCheckTag}
  //           eventTagItem={eventTagItem}
  //           category={memoizedCategory}
  //         />
  //       );
  //     case '상품 카테고리 모듈':
  //       return <HomeCategory key={module.sectionNo} el={module} index={index} category={memoizedCategory} />;
  //     case '최신 리뷰 모듈':
  //       return <MemberReview key={module.sectionNo} el={module} index={index} />;
  //     case '카테고리 별 리뷰 모듈':
  //       return <CategoryReview key={module.sectionNo} el={module} index={index} category={memoizedCategory} />;
  //     case '장바구니에 담긴 상품 모듈':
  //     case '최근 본 상품 모듈':
  //     case '최근 본 상품 기반 카테고리 내 다른 상품 모듈':
  //     case '찜한 목록에 담긴 상품 모듈':
  //     case '최근 구매한 상품 모듈':
  //       return <HomeCart key={module.sectionNo} el={module} index={index} category={memoizedCategory} />;
  //     case '세로형 모듈':
  //       return <BrandRecommend key={module.sectionNo} el={module} index={index} category={memoizedCategory} />;
  //     case '기획전 세로형 모듈':
  //       return (
  //         <EventProduct
  //           key={module.sectionNo}
  //           el={module}
  //           index={index}
  //           setTagName={setTagName}
  //           setCheckTag={setCheckTag}
  //           eventTagItem={eventTagItem}
  //           category={memoizedCategory}
  //         />
  //       );
  //     case '기획전 카테고리 모듈':
  //       return (
  //         <CategorySecond
  //           key={module.sectionNo}
  //           el={module}
  //           index={index}
  //           category={memoizedCategory}
  //           setTagName={setTagName}
  //           setCheckTag={setCheckTag}
  //           eventTagItem={eventTagItem}
  //         />
  //       );
  //     case '패션 카테고리 모듈':
  //       return <HomeCategorySecond key={module.sectionNo} el={module} index={index} category={memoizedCategory} />;
  //     default:
  //       return null;
  //   }
  // };

  const renderModule = useCallback(
    (module: HomeSectionType, index: number) => {
      switch (module.sectionName) {
        case '핫딜 모듈':
          if (hotDealCount !== 0) {
            return (
              <HotDeal
                key={module.sectionNo}
                el={module}
                index={index}
                setHotDealCount={setHotDealCount}
                category={memoizedCategory}
              />
            )
          }
          break
        case '퀵메뉴':
          return <HomeQuick key={module.sectionNo} el={module} index={index} menu={quickMenu} />
        case '검색 모듈':
          return (
            <PopularSearchKeyword key={module.sectionNo} el={module} index={index} popularKeyword={popularKeyword} />
          )
        case '카테고리 판매순 TOP4 모듈':
          return <CategoryRanking key={module.sectionNo} el={module} index={index} category={memoizedCategory} />
        case '조회수 TOP4 모듈':
        case '판매순 TOP4 모듈':
        case '검색량 TOP4 모듈':
          return (
            <CategoryRankingTop
              key={module.sectionNo}
              el={module}
              index={index}
              popularKeyword={popularKeyword}
              categorys={memoizedCategory}
            />
          )
        case '가로 스크롤 모듈':
          return <BrandTheme key={module.sectionNo} el={module} index={index} category={memoizedCategory} />
        // case '인플루언서 리뷰 모듈':
        //   return <HomeReview key={module.sectionNo} el={module} index={index} userData={userData} />;
        case '기획전 모듈':
          return (
            <HotEvent
              key={module.sectionNo}
              el={module}
              index={index}
              setTagName={setTagName}
              setCheckTag={setCheckTag}
              eventTagItem={eventTagItem}
              category={memoizedCategory}
            />
          )
        case '상품 카테고리 모듈':
          return <HomeCategory key={module.sectionNo} el={module} index={index} category={memoizedCategory} />
        case '최신 리뷰 모듈':
          return <MemberReview key={module.sectionNo} el={module} index={index} />
        case '카테고리 별 리뷰 모듈':
          return <CategoryReview key={module.sectionNo} el={module} index={index} category={memoizedCategory} />
        case '장바구니에 담긴 상품 모듈':
        case '최근 본 상품 모듈':
        case '최근 본 상품 기반 카테고리 내 다른 상품 모듈':
        case '찜한 목록에 담긴 상품 모듈':
        case '최근 구매한 상품 모듈':
          return <HomeCart key={module.sectionNo} el={module} index={index} category={memoizedCategory} />
        case '세로형 모듈':
          return <BrandRecommend key={module.sectionNo} el={module} index={index} category={memoizedCategory} />
        case '기획전 세로형 모듈':
          return (
            <EventProduct
              key={module.sectionNo}
              el={module}
              index={index}
              setTagName={setTagName}
              setCheckTag={setCheckTag}
              eventTagItem={eventTagItem}
              category={memoizedCategory}
            />
          )
        case '기획전 카테고리 모듈':
          return (
            <CategorySecond
              key={module.sectionNo}
              el={module}
              index={index}
              category={memoizedCategory}
              setTagName={setTagName}
              setCheckTag={setCheckTag}
              eventTagItem={eventTagItem}
            />
          )
        case '패션 카테고리 모듈':
          return <HomeCategorySecond key={module.sectionNo} el={module} index={index} category={memoizedCategory} />
        default:
          return null
      }
    },
    [quickMenu, memoizedCategory, hotDealCount, popularKeyword, userData, setTagName, setCheckTag, eventTagItem]
  )

  return <>{homeModules?.map((module, index) => renderModule(module, index))}</>
}

export default memo(HomeModules)
